import ConfirmDetails from './ConfirmDetails';

export default ConfirmDetails;
